import { useEffect, useRef } from "react";
import { useLoader } from "contexts";

/**
 * Shows the global loader while a query is fetching and hides it again when
 * the request ends or the component unmounts (never hides more than it showed).
 */
const useQueryLoader = (isFetching) => {
  const { showLoader, hideLoader } = useLoader();
  const shownRef = useRef(false);

  useEffect(() => {
    if (isFetching && !shownRef.current) {
      shownRef.current = true;
      showLoader();
    } else if (!isFetching && shownRef.current) {
      shownRef.current = false;
      hideLoader();
    }
  }, [isFetching, showLoader, hideLoader]);

  useEffect(
    () => () => {
      if (shownRef.current) {
        shownRef.current = false;
        hideLoader();
      }
    },
    [hideLoader],
  );
};

export default useQueryLoader;
